"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilService = void 0;
const AttrService_1 = require("./AttrService");
class UtilService {
    static newUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
            const // tslint:disable-next-line:no-bitwise
            randomNumber = (Math.random() * 16) | 0, newChar = char === 'x'
                ? randomNumber
                : // tslint:disable-next-line:no-bitwise
                    (randomNumber & 0x3) | 0x8;
            return newChar.toString(16);
        });
    }
    static getElementWidthWithoutPaddings(element) {
        if (!element)
            return;
        const elementWidth = element.getBoundingClientRect().width;
        const leftPadding = window.getComputedStyle(element, null).getPropertyValue('padding-left');
        const rightPadding = window.getComputedStyle(element, null).getPropertyValue('padding-right');
        return elementWidth - parseInt(leftPadding, 10) - parseInt(rightPadding, 10);
    }
    static getOffsetHeight(contextElement, selector) {
        const element = contextElement.querySelector(selector);
        return element ? element.offsetHeight : 0;
    }
    static getCSSValue(element, cssRule) {
        const elStyles = getComputedStyle(element);
        const cssRuleValueStr = elStyles.getPropertyValue(cssRule);
        return parseFloat(cssRuleValueStr) || 0;
    }
    static getCookieCategoriesAcceptance() {
        const CookieInformation = window['CookieInformation'];
        const functionalCookiesCategory = 'cookie_cat_functional';
        const marketingCookiesCategory = 'cookie_cat_marketing';
        const statisticCookiesCategory = 'cookie_cat_statistic';
        if (!CookieInformation || !CookieInformation.getConsentGivenFor)
            return;
        return {
            functional: CookieInformation.getConsentGivenFor(functionalCookiesCategory),
            marketing: CookieInformation.getConsentGivenFor(marketingCookiesCategory),
            statistic: CookieInformation.getConsentGivenFor(statisticCookiesCategory),
        };
    }
    static getAnalyticsUserId() {
        const panelContainer = document.querySelector('.header');
        return panelContainer ? AttrService_1.AttrService.data(panelContainer, 'analytics-user-id') : '';
    }
    static setAttributes(el, attrs) {
        for (const key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }
    static generateUniqueID(quantity) {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
        let result = '';
        for (let i = 0; i < quantity; i++) {
            const randomIndex = Math.floor(Math.random() * letters.length);
            result += letters.charAt(randomIndex);
        }
        return result;
    }
    static isArraysAreEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            const item1 = arr1[i];
            const item2 = arr2[i];
            if (Array.isArray(item1) && Array.isArray(item2)) {
                if (!this.isArraysAreEqual(item1, item2)) {
                    return false;
                }
            }
            else if (typeof item1 === 'object' && typeof item2 === 'object') {
                if (!this.isObjectsAreEqual(item1, item2)) {
                    return false;
                }
            }
            else if (item1 !== item2) {
                return false;
            }
        }
        return true;
    }
    static isObjectsAreEqual(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = obj1[key];
            const val2 = obj2[key];
            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (!this.isArraysAreEqual(val1, val2)) {
                    return false;
                }
            }
            else if (typeof val1 === 'object' && typeof val2 === 'object') {
                if (!this.isObjectsAreEqual(val1, val2)) {
                    return false;
                }
            }
            else if (val1 !== val2) {
                return false;
            }
        }
        return true;
    }
    static getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }
}
exports.UtilService = UtilService;
// From : https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
UtilService.PromiseRetryPolicy = (func, n) => func().catch(function (error) {
    if (n === 1) {
        throw error;
    }
    return UtilService.PromiseRetryPolicy(func, n - 1);
});
UtilService.parseLanguageCode = (culture) => {
    let languageCode = 'en';
    if (culture) {
        languageCode = culture.indexOf('-') ? culture.split('-')[0] : culture;
    }
    return languageCode;
};
UtilService.globalCountry = 'global_country';
UtilService.parseCountryCode = (culture) => {
    if (culture && culture.indexOf('-') !== -1) {
        return culture.split('-')[1];
    }
    return UtilService.globalCountry;
};
